<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="所属仓库" prop="warehouseName">
              {{ formData.warehouseName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存储数量" prop="manQuantity">
              {{ formData.manQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属客户" prop="userId" placeholder="请选择所属客户">
              {{ formData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="流水记录" prop="">
              <el-table size="mini" stripe border :data="tableData">
                <el-table-column min-width="230" label="关联工单" prop="objNum">
                  <template v-slot="{ row }">
                    <el-button type="text" size="mini" @click="handleClick(row)">{{ row.objNum }}</el-button>
                    <el-button v-if="row.objNum" type="text" size="mini" @click.stop="handleCopyObjNum(row.objNum)">复制</el-button>
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属仓库"
                                 prop="warehouseName"></el-table-column>
                <el-table-column min-width="80" :show-overflow-tooltip="true" label="类型" prop="ygType">
                  <template v-slot="{ row }">
                    {{ row.ygType === 'B' ? '入库' : row.ygType === 'A3' ? '货转调拨' : '出库' }}
                  </template>
                </el-table-column>
                <el-table-column min-width="100" :show-overflow-tooltip="true" label="出入库类型" prop="recType">
                  <template v-slot="{ row }">
                    {{ cyRecTypeMap.get(row.recType) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格"
                                 prop="specName"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="所属客户"
                                 prop="userName"></el-table-column>
                <el-table-column min-width="100" label="数量"
                                 prop="recQuantity"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录时间"
                                 prop="ctime"></el-table-column>
                <el-table-column min-width="200" :show-overflow-tooltip="true" label="记录来源" prop="sourceType">
                  <template v-slot="{ row }">
                    {{ recordSourceTypeMap.get(row.sourceType) }}
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next"
                             :total="total" @current-change="loadData">
              </el-pagination>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { cyRecType, recordSourceType } from '@/utils/dict'
import { copyText } from '@/utils/utils'

export default {
  name: 'InventoryManageDetail',
  data() {
    return {
      cyRecTypeMap: cyRecType,
      recordSourceTypeMap: recordSourceType,
      formData: {
        id: '', // 主键
        warehouseId: '', // 仓库id
        specId: '', // 规格id
        manQuantity: '', // 存储数量
        userId: '' // 所属客户id
      },
      tableData: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    async handleCopyObjNum(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    handleClick(row) {
      switch (row.sourceType) {
        case 'TH':
          this.$router.push(`/deliveryOrder/detail?pickupId=${row.objId}`)
          break
        case 'YC':
          this.$router.push(`/ycdeliveryOrder/detail?pickupId=${row.objId}`)
          break
        case 'CY':
          this.$router.push(`/cyCrkManage/detail?inventoryId=${row.objId}`)
          break
        case 'SC':
          this.$router.push(`/productrecord/detail?recordId=${row.objId}`)
          break
        default:
          break
      }
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectLyWareManById, {
        params: { id: this.id }
      }).then(res => {
        this.formData = res
        this.loadData()
      })
    },
    loadData() {
      this.$axios.get(this.$apis.prodManage.selectLyWareRecByPage, {
        page: this.page,
        size: 10,
        warehouseId: this.formData.warehouseId,
        specId: this.formData.specId,
        userId: this.formData.userId
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select, .el-input, .el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {
  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
